import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { SideMenuLinkIconBase } from "./base/side-menu-link-icon-base.box";

const Club888SideMenuDefaultIcon = styled(SideMenuLinkIconBase)`
    background-position: -194px -422px;
`;

export const Club888SideMenuIcon = styledByTheme(Club888SideMenuDefaultIcon).apply();
